module.exports = __webpack_public_path__ + "static/media/About-Us-banner-2x.15874702.jpg";